App.ClientOrderBlockComponent = Em.Component.extend
  classNames: 'client-order-block'
  classNameBindings: ['isOpen']

  env: Em.inject.service('environment')
  notifier: Em.inject.service()

  orderStatus: (->
    @get('env').translate("order.status.#{@get('order.status')}")
  ).property('order.status')

  isLoading: false

  orderButtonType: (->
    if @get('order.client_rate_processed') then 'secondary' else 'primary'
  ).property('order.client_rate_processed')

  orderButtonTranslation: (->
    if @get('order.client_rate_processed') then 'c.client_order_block.unprocess' else 'c.client_order_block.process'
  ).property('order.client_rate_processed')

  showClientRateBlock: (->
    channels = @get('env.features.communicationChannels')
    clientRate = @get('order.client_rate')
    return unless channels
    return unless clientRate
    channels && clientRate
  ).property(
    'env.features.communicationChannels', 
    'order.client_rate')

  showClientRateButton:(->
    channels = @get('env.features.communicationChannels')
    clientRateToProcessed = @get('env.features.clientRateToProcessed')
    clientRate = @get('order.client_rate')
    clientRateAt = @get('order.client_rated_at')
    
    return unless channels
    return unless clientRateAt
    return unless clientRateToProcessed
    
    clientRate <= clientRateToProcessed
  ).property(
    'env.features.communicationChannels', 
    'env.features.clientRateToProcessed', 
    'order.client_rate', 
    'order.client_rated_at')


  onOpenChange: (->
    if @get('isOpen')
      @$('.order-body').slideDown({duration: 100})
    else
      @$('.order-body').slideUp({duration: 100})
  ).observes('isOpen')

  click: (e) ->
    return if e.target.closest('.actions') 
    @sendAction('onClick', @get('order.id'))

  actions: 
    processOrder: ->
      order = @get('order')
      return if @get('isLoading')
      @set('isLoading', true)
      order.toggleProperty('client_rate_processed')
      order.processRate()
      .then =>
        @sendAction('reloadClient')
      .catch =>
        @get('notifier').pushNotification
          type:'error'
          title: Em.I18n.t 'order.courier_mini_popup.annotation.error'
          message: Em.I18n.t  'c.client_order_block.process_error'
        order.rollback()
      .finally =>
        @set('isLoading', false) unless @get('isDestroyed')

  


